import AxiosService from '@/services/AxiosServices'

export default {
  /**
   * Get list of Finishes
   *
   * @param perPage => limit
   * @param page => item by page
   * @param order => obj with index and ASC or DESC
   * @param search => research
   * @returns {*}
   */
  getFinishes(perPage, page, order, search) {
    let url = 'admin/finishes'
    if(perPage)
      url += '?_limit=' + perPage + '&_page=' + page
    if(order !== null)
      url += '&_index=' + order.index + '&_order=' + order.order
    if(search !== null)
      url += '&_search=' + search

    return AxiosService.callApi().get(url)
  },
  /**
   * Get Finishing by id
   *
   * @param id
   * @returns {*}
   */
  getFinishing(id) {
    return AxiosService.callApi().get('/admin/finishes/' + id)
  },
  /**
   * Create Finishing
   *
   * @param data
   * @returns {*}
   */
  create(data) {
    return AxiosService.callApi().post('/admin/finishes', data)
  },
  /**
   * Edit Finishing
   *
   * @param id
   * @param data
   * @returns {*}
   */
  edit(id, data) {
    return AxiosService.callApi().put('/admin/finishes/' + id, data)
  },
  /**
   * Delete Finishing
   *
   * @param id
   * @returns {*}
   */
  delete(id) {
    return AxiosService.callApi().delete('/admin/finishes/' + id)
  }
}
